// extracted by mini-css-extract-plugin
export default {"tela":"ModuloTravado_tela__Od94T","voltar":"ModuloTravado_voltar__o19We"};